import { spaceToPx } from 'canoe';
import { connectWithHammock, ENDPOINTS } from 'hammock';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

import DropInContainer from 'craft/components/DropInContainer';

const Container = styled.div`
  margin-bottom: ${spaceToPx('xs')}px;
`;

interface BlockDropInProps {
  editorDocument: any;
  children: ReactNode;
}

const BlockDropIn = ({ editorDocument, children }: BlockDropInProps) => {
  return (
    <DropInContainer id="blockTemplate" contentDocument={editorDocument.document} noStyles>
      <Container>{children}</Container>
    </DropInContainer>
  );
};

export const BlockDropInComponent = connectWithHammock(({ templateId }) => ({
  resourceName: 'editorDocument',
  endpoint: ENDPOINTS.templateDocumentsEditor,
  id: templateId,
}))(BlockDropIn);
